import { render } from "./ContactTablePreview.vue?vue&type=template&id=42ff4036"
import script from "./ContactTablePreview.vue?vue&type=script&lang=js"
export * from "./ContactTablePreview.vue?vue&type=script&lang=js"

import "./ContactTablePreview.vue?vue&type=style&index=0&id=42ff4036&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__